/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4cfb1ad7876c05791ac75edd1a1818fadec73770";
